import { useAuth, useAutoSignin } from 'react-oidc-context'
import './App.css'

function Page({ children }: { children: React.ReactNode }) {
  return (
    <main className="page">
      <h1>OAuth Test Client</h1>
      <p className="subtitle">Client di prova per il server OAuth locale</p>
      {children}
    </main>
  )
}

function App() {
  const auth = useAuth()
  useAutoSignin()

  switch (auth.activeNavigator) {
    case 'signinSilent':
    case 'signinRedirect':
      return (
        <Page>
          <p className="status">Signing you in...</p>
        </Page>
      )
    case 'signoutRedirect':
      return (
        <Page>
          <p className="status">Signing you out...</p>
        </Page>
      )
  }

  if (auth.isLoading) {
    return (
      <Page>
        <p className="status">Loading...</p>
      </Page>
    )
  }

  if (auth.error) {
    return (
      <Page>
        <p className="error">
          Oops... {auth.error.source} caused {auth.error.message}
        </p>
      </Page>
    )
  }

  if (auth.isAuthenticated) {
    return (
      <Page>
        <div className="profile">
          <p className="profile-label">Signed in as</p>
          <p className="profile-name">
            {auth.user?.profile.preferred_username ?? auth.user?.profile.sub}
          </p>
          {auth.user?.profile.email && (
            <p className="profile-email">{auth.user.profile.email}</p>
          )}
        </div>
        <div className="actions">
          <button className="secondary" onClick={() => void auth.removeUser()}>
            Log out
          </button>
        </div>
      </Page>
    )
  }

  return (
    <Page>
      <p className="status">Redirecting to login...</p>
    </Page>
  )
}

export default App
